import styles from "./styles.module.css";
import TasksTable from "@/components/organisms/TasksTable";
import { useTranslation } from "react-i18next";
import { Box } from "@mantine/core";
import { DEFAULT_TASK_COLUMNS } from "@/components/organisms/InvoiceTable/const/default";
import { SubHeader } from "@/components/molecules/SubHeader";
import { useGetOpenTasks } from "@/services/Tasks";
import { useAuth } from "@/contexts/AuthContext";

export default function Tasks() {
  const { t } = useTranslation();
  const { currentCompany } = useAuth();

  const { data: tasks } = useGetOpenTasks(currentCompany?.companyId as number, undefined, {
    enabled: !!currentCompany?.companyId,
  });

  return (
    <>
      <title>{`Reviver - ${t("common:tasks")}`}</title>
      <meta name="description" content={`Reviver - ${t("common:tasks")}`} />
      <SubHeader title={t("navigation:tasks")} count={tasks?.length} countLabel={t("common:tasks")} />
      <Box className={styles.tasksRoot}>
        <div className={styles.tasksContent}>
          <TasksTable visibleColumns={DEFAULT_TASK_COLUMNS} initialSort={[]} initialRowsPerPage={15} />
        </div>
      </Box>
    </>
  );
}
